"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ErrorMessageSection = void 0;
var _mui = require("@ori-ui/mui");
var _jsxRuntime = require("react/jsx-runtime");
const ErrorMessageSection = ({
  statusCode,
  owner
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Box, {
  mb: 3,
  children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Typography, {
    gutterBottom: true,
    variant: "subtitle1",
    children: ["Page Error Code: ", statusCode]
  }), owner ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Typography, {
    variant: "body2",
    color: "textSecondary",
    children: ["Page Owner: ", owner]
  }) : null]
});
exports.ErrorMessageSection = ErrorMessageSection;
